import { render, staticRenderFns } from "./userlike-privacy-dialog.vue?vue&type=template&id=4e35c3c0&"
import script from "./userlike-privacy-dialog.vue?vue&type=script&lang=js&"
export * from "./userlike-privacy-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports